var Hookable = /** @class */ (function () {
    function Hookable(_a) {
        var hook = _a.hook;
        this.hook = hook;
    }
    return Hookable;
}());
export default Hookable;
export * from './types';
